export default __webpack_public_path__ + "static/learn-coding-9a59f31d5411e5e473c30fbe70d2e9ea.webp";